var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload"},[_vm._t("upload_con"),_c('input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"uploadFile",attrs:{"type":"file","multiple":_vm.multiple,"accept":_vm.accept.join(',')},on:{"change":_vm.changeFile}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }